import { Cache, createClient, defaultResponseHandler } from 'gqty';
import { accessTokenFromOidcStorage } from '../../utils/oidc-session';
import { generatedSchema, scalarsEnumsHash } from './schema.generated';
export const storageOrigin = () => ((typeof __JAEN_STORAGE_URL__ !== 'undefined' && __JAEN_STORAGE_URL__) ||
    'https://osg.snek.at').replace(/\/+$/, '');
export const storageFileUrl = (fileId) => `${storageOrigin()}/storage/${encodeURIComponent(fileId)}`;
const KNOWN_STORAGE_HOSTS = ['osg.snek.at', 'osg.netsnek.com', 'osg.jaen.io'];
export const storageFileId = (idOrUrl) => {
    const value = idOrUrl.trim();
    if (value === '')
        return null;
    if (!/^https?:\/\//i.test(value)) {
        return value.startsWith('/') ? null : value;
    }
    let url;
    try {
        url = new URL(value);
    }
    catch {
        return null;
    }
    const origin = storageOrigin();
    const isOurs = KNOWN_STORAGE_HOSTS.includes(url.hostname) ||
        (origin !== '' && value.startsWith(`${origin}/`));
    if (!isOurs)
        return null;
    const match = /^\/storage\/(.+)$/.exec(url.pathname);
    return match ? decodeURIComponent(match[1]) : null;
};
export const storageBearer = () => {
    try {
        if (typeof sessionStorage !== 'undefined') {
            const token = accessTokenFromOidcStorage(sessionStorage.getItem(`oidc.user:${__JAEN_ZITADEL_GQL__.authority}:${__JAEN_ZITADEL_GQL__.clientId}`));
            if (token)
                return token;
        }
    }
    catch {
    }
    try {
        const env = globalThis
            .process?.env;
        if (env?.['OSG_TOKEN'])
            return env['OSG_TOKEN'];
    }
    catch {
    }
    return undefined;
};
const buildMultipartForm = (query, variables) => {
    const form = new FormData();
    const operations = { query, variables: structuredClone(variables ?? {}) };
    const map = {};
    const files = [];
    let index = 0;
    const setAt = (obj, path, value) => {
        let cursor = obj;
        for (let i = 0; i < path.length - 1; i++)
            cursor = cursor[path[i]];
        cursor[path[path.length - 1]] = value;
    };
    const walk = (value, path = []) => {
        if (value instanceof File || value instanceof Blob) {
            map[index] = [`variables.${path.join('.')}`];
            setAt(operations.variables, path, null);
            files.push({ index, file: value });
            index++;
        }
        else if (Array.isArray(value)) {
            value.forEach((item, i) => walk(item, [...path, i]));
        }
        else if (value && typeof value === 'object') {
            Object.entries(value).forEach(([key, val]) => walk(val, [...path, key]));
        }
    };
    walk(operations.variables);
    form.append('operations', JSON.stringify(operations));
    form.append('map', JSON.stringify(map));
    files.forEach(({ index: i, file }) => form.append(String(i), file));
    return form;
};
const queryFetcher = async ({ query, variables }, fetchOptions) => {
    const token = storageBearer();
    const response = await fetch(`${storageOrigin()}/graphql`, {
        method: 'POST',
        body: buildMultipartForm(query, variables),
        mode: 'cors',
        ...fetchOptions,
        headers: {
            ...fetchOptions?.headers,
            ...(token ? { Authorization: `Bearer ${token}` } : {})
        }
    });
    return await defaultResponseHandler(response);
};
export const osgCache = new Cache(undefined, {
    maxAge: Infinity,
    staleWhileRevalidate: 5 * 60 * 1000,
    normalization: true
});
export const osg = createClient({
    schema: generatedSchema,
    scalars: scalarsEnumsHash,
    cache: osgCache,
    fetchOptions: { fetcher: queryFetcher }
});
